import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { LoadingState } from "@how/ui";
import { useSession } from "./session";

/** Redirects signed-out visitors to the sign-in route, remembering where they were going. */
export function RequireSession({
  children,
  signInPath = "/sign-in",
}: {
  children: ReactNode;
  signInPath?: string;
}) {
  const session = useSession();
  const location = useLocation();
  if (session.status === "loading") return <LoadingState label="Checking your session" />;
  if (session.status === "signed_out") {
    return <Navigate to={signInPath} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
